import { $teamOccupancy, $teams } from './states';
import { fetchTeamOccupancy, fetchTeams } from './effects';

// Teams
$teams.on(fetchTeams.doneData, (_, data) => data);

// Team occupancy
$teamOccupancy.on(fetchTeamOccupancy.doneData, (_, data) => data);
